export { default, initialize } from 'ember-can/initializers/setup-ember-can';
